var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealthcare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8 7.2H16.8V1.2C16.8 0.54 16.26 0 15.6 0H8.4C7.74 0 7.2 0.54 7.2 1.2V7.2H1.2C0.54 7.2 0 7.74 0 8.4V15.6C0 16.26 0.54 16.8 1.2 16.8H7.2V22.8C7.2 23.46 7.74 24 8.4 24H15.6C16.26 24 16.8 23.46 16.8 22.8V16.8H22.8C23.46 16.8 24 16.26 24 15.6V8.4C24 7.74 23.46 7.2 22.8 7.2ZM21.6 14.4H14.4V21.6H9.6V14.4H2.4V9.6H9.6V2.4H14.4V9.6H21.6V14.4Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthcare);
export default __webpack_public_path__ + "static/media/healthcare.2d734e8bb14e836b96c97a952c4decf9.svg";
export { ForwardRef as ReactComponent };